module.exports = __webpack_public_path__ + "img/clogo.108f2086.png";